import tags from '../tags';

const {
  passives: {
    offensivePassive,
    defensivePassive,
    resourcePassive,
    mobilityPassive,
    cooldownPassive,
  },
} = tags;

export default [
  {
    name: 'Blur',
    tags: [defensivePassive],
  },
  {
    name: 'Power Hungry',
    tags: [offensivePassive],
  },
  {
    name: 'Evocation',
    tags: [cooldownPassive],
  },
  {
    name: 'Glass Cannon',
    tags: [offensivePassive],
  },
  {
    name: 'Prodigy',
    tags: [resourcePassive],
  },
  {
    name: 'Astral Presence',
    tags: [resourcePassive],
  },
  {
    name: 'Illusionist',
    tags: [mobilityPassive, cooldownPassive],
  },
  {
    name: 'Cold Blooded',
    tags: [offensivePassive],
  },
  {
    name: 'Conflagration',
    tags: [offensivePassive],
  },
  {
    name: 'Paralysis',
    tags: [],
  },
  {
    name: 'Galvanizing Ward',
    tags: [defensivePassive],
  },
  {
    name: 'Temporal Flux',
    tags: [],
  },
  {
    name: 'Dominance',
    tags: [defensivePassive],
  },
  {
    name: 'Arcane Dynamo',
    tags: [offensivePassive],
  },
  {
    name: 'Unstable Anomaly',
    tags: [defensivePassive],
  },
  {
    name: 'Unwavering Will',
    tags: [defensivePassive, offensivePassive],
  },
  {
    name: 'Audacity',
    tags: [offensivePassive],
  },
  {
    name: 'Elemental Exposure',
    tags: [offensivePassive],
  },
];
